// What a chat message may hold (backend routes/bots.py BotMessageCreate.content) and what
// happens to longer text: a long paste becomes a text file attached to the message, as in
// claude.ai ("detect it as a large paste and turn it into a file attachment", Simon Willison,
// 2026-06-02), so a pasted CLAUDE.md never fails with "The message could not be sent".
export const MESSAGE_MAX = 8000;
export const PASTE_AS_FILE = 4000;  // a paste this long goes in as a file even below the limit

/** Whether a paste of `text` into a message that already holds `current` should become a file. */
export const pasteAsFile = (text, current = '') => !!text
  && (text.length > PASTE_AS_FILE || current.length + text.length > MESSAGE_MAX);

export const pastedTextFile = (text) => new File([text], 'pasted-text.txt', { type: 'text/plain' });

/** The API refused the message for its length (FastAPI's validation error). */
export const isTooLong = (err) => err?.response?.status === 422
  && Array.isArray(err.response.data?.detail)
  && err.response.data.detail.some((d) => d?.type === 'string_too_long');
